// extracted by mini-css-extract-plugin
export default {"InputDiv":"AutocompleteAsyncInput_InputDiv__UtlGu","listItemIcon":"AutocompleteAsyncInput_listItemIcon__xGX7i","text-black":"AutocompleteAsyncInput_text-black__8ebJX"};